<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 123.103 48.85">
    <g id="MPV" transform="translate(10739.52 -314.12)">
      <path id="Path_87107" data-name="Path 87107"
        d="M42.811,452.353A10.051,10.051,0,1,0,52.862,462.4a10.063,10.063,0,0,0-10.051-10.051m0,17.763a7.712,7.712,0,1,1,7.712-7.712,7.719,7.719,0,0,1-7.712,7.712"
        transform="translate(-10678.712 -109.486)" :fill="themeColor" />
      <path id="Path_87108" data-name="Path 87108"
        d="M13.457,452.353h-.006A10.054,10.054,0,0,0,3.4,462.4a10.082,10.082,0,0,0,10.048,10.054h.006a10.051,10.051,0,0,0,0-20.1m-.006,17.763a7.712,7.712,0,1,1,7.712-7.712,7.719,7.719,0,0,1-7.712,7.712"
        transform="translate(-10733.201 -109.486)" :fill="themeColor" />
      <path id="Path_87109" data-name="Path 87109"
        d="M19.772,459.842l76.354.38c1.608.437,3.23.806,4.821,1.094a45.412,45.412,0,0,1,13.285,4.162c3.8,2.651,5.924,11.08,6.541,15.181a1.177,1.177,0,0,0,.463.774,1.191,1.191,0,0,0,.868.217,1.173,1.173,0,0,0,.985-1.331c-.706-4.741-3.022-13.542-7.249-16.592a43.658,43.658,0,0,0-14.239-4.656,58.092,58.092,0,0,1-9.189-2.456c-1.9-.828-4.41-2.051-7.241-3.433a191.041,191.041,0,0,0-17.6-7.889c-16.275-5.721-46.777-1.6-50.2-1.111-8.977.2-12.525,14.835-13.145,17.766l-.211.5L.952,467a1.1,1.1,0,0,0-.18.44,21.465,21.465,0,0,0,.74,13.63,1.135,1.135,0,0,0,.848.583l.189,0a1.192,1.192,0,0,0,.5-.111,1.172,1.172,0,0,0,.56-1.554,18.754,18.754,0,0,1-.586-11.742l.191-.411,3.042-4.524a1.353,1.353,0,0,0,.183-.443c.029-.154,3.239-16.358,10.951-16.358,1.508-.206,33.156-4.736,49.468.988a179.912,179.912,0,0,1,16.881,7.572l5.584,2.739-69.554-.3a1.168,1.168,0,0,0,.006,2.336"
        transform="translate(-10739.52 -128.169)" :fill="themeColor" />
      <path id="Path_87110" data-name="Path 87110"
        d="M63.252,456.417a1.169,1.169,0,0,0-1.168-1.165h-48.2a1.167,1.167,0,1,0,0,2.334h48.2a1.17,1.17,0,0,0,1.168-1.168"
        transform="translate(-10715.914 -104.105)" :fill="themeColor" />
    </g>
  </svg>

</template>

<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
